export const environment = {
  production: true,
  tasks_endpoint: 'https://tasks-wave.mobivate.com'
};
